<template>
    <div>
    <!-- Mobile Filters Modal -->
    <UiModalMobile
        v-if="useIsMobileValue"
        :isOpen="isOpen"
        title="Filters"
        @close="$emit('close')"
    >
        <template #content>
            <div class="space-y-6">
                <!-- Program type -->
                <div>
                    <div class="text-slate-800 dark:text-slate-100 text-sm font-medium">
                        Program type
                    </div>
                    <div class="mt-4 space-y-3">
                        <label
                            v-for="option in programTypeOptions"
                            :key="option.id"
                            class="flex items-center gap-3 cursor-pointer select-none"
                            @click.prevent="toggleProgramTypeSelection(option)"
                        >
                            <input
                                type="checkbox"
                                class="rounded text-10x-orange"
                                :checked="isProgramTypeSelected(option)"
                                @click.stop
                                @change="toggleProgramTypeSelection(option)"
                            />
                            <span class="text-slate-800 dark:text-slate-100 text-sm">
                                {{ option.name }}
                            </span>
                        </label>
                    </div>
                </div>

                <hr class="border-slate-200 dark:border-slate-700" />

                <!-- Added to My Points -->
                <div>
                    <div class="text-slate-800 dark:text-slate-100 text-sm font-medium">
                        Added to My Points
                    </div>
                    <div
                        v-if="isSingleUser"
                        class="mt-4 flex items-center justify-between"
                    >
                        <span class="text-slate-800 dark:text-slate-100 text-sm">
                            Only programs added to My Points
                        </span>
                        <Switch
                            :value="singleUserToggle"
                            label="Only programs added to My Points"
                            @input="$emit('update:singleUserToggle', $event)"
                        />
                    </div>
                    <div v-else class="mt-4 space-y-3">
                        <label
                            v-for="option in addedToMyPointsOptions"
                            :key="option.id"
                            class="flex items-center gap-3 cursor-pointer select-none"
                            @click.prevent="toggleAddedToMyPointsSelection(option)"
                        >
                            <input
                                type="checkbox"
                                class="rounded text-10x-orange"
                                :checked="isAddedToMyPointsSelected(option)"
                                @click.stop
                                @change="toggleAddedToMyPointsSelection(option)"
                            />
                            <span class="text-slate-800 dark:text-slate-100 text-sm">
                                {{ option.name }}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex items-center justify-between">
                <button
                    type="button"
                    class="px-4 py-2.5 rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm font-medium hover:bg-gray-50 dark:hover:bg-slate-700"
                    @click="handleClearAllMobile()"
                >
                    Clear all
                </button>
                <button
                    type="button"
                    class="px-4 py-2.5 rounded bg-slate-800 text-white text-sm font-medium hover:bg-slate-700"
                    @click="applyMobileFilters()"
                >
                    Show programs
                </button>
            </div>
        </template>
    </UiModalMobile>

    <!-- Desktop Filters Sidebar -->
    <BaseSidebar
        v-else
        :isOpen="isOpen"
        title="Filters"
        @close="$emit('close')"
        :customClasses="[
            'right-3 left-auto bottom-3 top-0 max-w-md w-auto rounded-lg border border-slate-200 dark:border-slate-700 ring-1 ring-white ring-opacity-5',
        ]"
    >
        <template #default>
            <div class="px-6 pt-2 pb-6 space-y-6">
                <!-- Program type -->
                <div>
                    <div class="text-slate-800 dark:text-slate-100 text-sm font-medium">
                        Program type
                    </div>
                    <div class="mt-4 space-y-3">
                        <label
                            v-for="option in programTypeOptions"
                            :key="option.id"
                            class="flex items-center gap-3 cursor-pointer select-none"
                            @click.prevent="toggleProgramTypeSelection(option)"
                        >
                            <input
                                type="checkbox"
                                class="rounded text-10x-orange"
                                :checked="isProgramTypeSelected(option)"
                                @click.stop
                                @change="toggleProgramTypeSelection(option)"
                            />
                            <span class="text-slate-800 dark:text-slate-100 text-sm">
                                {{ option.name }}
                            </span>
                        </label>
                    </div>
                </div>

                <hr class="border-slate-200 dark:border-slate-700" />

                <!-- Added to My Points -->
                <div>
                    <div class="text-slate-800 dark:text-slate-100 text-sm font-medium">
                        Added to My Points
                    </div>
                    <div
                        v-if="isSingleUser"
                        class="mt-4 flex items-center justify-between"
                    >
                        <span class="text-slate-800 dark:text-slate-100 text-sm">
                            Only programs added to My Points
                        </span>
                        <Switch
                            :value="singleUserToggle"
                            label="Only programs added to My Points"
                            @input="$emit('update:singleUserToggle', $event)"
                        />
                    </div>
                    <div v-else class="mt-4 space-y-3">
                        <label
                            v-for="option in addedToMyPointsOptions"
                            :key="option.id"
                            class="flex items-center gap-3 cursor-pointer select-none"
                            @click.prevent="toggleAddedToMyPointsSelection(option)"
                        >
                            <input
                                type="checkbox"
                                class="rounded text-10x-orange"
                                :checked="isAddedToMyPointsSelected(option)"
                                @click.stop
                                @change="toggleAddedToMyPointsSelection(option)"
                            />
                            <span class="text-slate-800 dark:text-slate-100 text-sm">
                                {{ option.name }}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex items-center justify-between">
                <button
                    type="button"
                    class="px-4 py-2.5 rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm font-medium hover:bg-gray-50 dark:hover:bg-slate-700"
                    @click="handleClearAllMobile()"
                >
                    Clear all
                </button>
                <button
                    type="button"
                    class="px-4 py-2.5 rounded bg-slate-800 text-white text-sm font-medium hover:bg-slate-700"
                    @click="applyMobileFilters()"
                >
                    Show programs
                </button>
            </div>
        </template>
    </BaseSidebar>
    </div>
</template>

<script setup>
import UiModalMobile from '@/components/ui/modal/ui-modal-mobile.vue';
import BaseSidebar from '@/components/ui/base-sidebar.vue';
import Switch from '@/components/ui/switch/switch.vue';
import { useIsMobile } from '@/composables/useIsMobile';

const { isMobile: useIsMobileValue } = useIsMobile();

defineProps({
    isOpen: { type: Boolean, default: false },
    programTypeOptions: { type: Array, default: () => [] },
    addedToMyPointsOptions: { type: Array, default: () => [] },
    selectedProgramTypes: { type: Array, default: () => [] },
    selectedAddedToMyPoints: { type: Array, default: () => [] },
    singleUserToggle: { type: Boolean, default: false },
    isSingleUser: { type: Boolean, default: false },
    isProgramTypeSelected: { type: Function, required: true },
    isAddedToMyPointsSelected: { type: Function, required: true },
    toggleProgramTypeSelection: { type: Function, required: true },
    toggleAddedToMyPointsSelection: { type: Function, required: true },
    handleClearAllMobile: { type: Function, required: true },
    applyMobileFilters: { type: Function, required: true },
});

defineEmits(['close', 'update:singleUserToggle']);
</script>
